export default function Checkbox({ identifier, mandatory, value, onChange, disabled }) {
    return (
        <input
            type="checkbox"
            name={identifier}
            id={identifier}
            className={`checkbox-input default-input ${mandatory ? "mandatory-input" : ""}`}
            onChange={(e) => onChange(e)}
            checked={value}
            required={mandatory}
        ></input>
    );
}